module.exports = __webpack_public_path__ + "static/img/bg_vip_desc_dialog_bg_3.124b6df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_vip_desc_dialog_bg_3.png
// module id = UimF
// module chunks = 0